"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SortDirection = require("./SortDirection");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SortIcon = _ref => {
  let {
    sortDirection,
    altText
  } = _ref;
  const Icon = (0, _SortDirection.getSortDirectionIcon)(sortDirection);
  return /*#__PURE__*/_react.default.createElement(Icon, {
    className: "h-full w-full",
    "aria-label": altText
  });
};
var _default = exports.default = SortIcon;